import { render, staticRenderFns } from "./PcrRapidTest.vue?vue&type=template&id=440fceb8&scoped=true&"
import script from "./PcrRapidTest.vue?vue&type=script&lang=js&"
export * from "./PcrRapidTest.vue?vue&type=script&lang=js&"
import style0 from "./PcrRapidTest.vue?vue&type=style&index=0&id=440fceb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440fceb8",
  null
  
)

export default component.exports